import type { Lang, LocalePack } from "./types";
import en from "./locales/en";
import sectionsEn from "./sections/en";
import extraEn from "./extra/en";

// English ships in the main bundle: it is the default and the prerendered HTML
// is English, so hydration always starts from this pack. Every other language
// is a separate chunk fetched only for visitors who use it.
export const enPack: LocalePack = { lang: "en", locale: en, sections: sectionsEn, extra: extraEn };

export type PackLoader = () => Promise<{ default: LocalePack }>;

const packLoaders: Record<Exclude<Lang, "en">, PackLoader> = {
  es: () => import("./packs/es"),
  fr: () => import("./packs/fr"),
  pt: () => import("./packs/pt"),
  it: () => import("./packs/it"),
  de: () => import("./packs/de"),
  ar: () => import("./packs/ar"),
  ru: () => import("./packs/ru"),
};

let current: LocalePack = enPack;

/**
 * Loads the pack for `lang` and records it as the current one. Falls back to
 * English when the chunk cannot be fetched so the page still renders; the
 * caller decides whether that is worth reporting.
 */
export async function loadLocale(lang: Lang, loader?: PackLoader): Promise<LocalePack> {
  if (lang === "en") {
    current = enPack;
    return current;
  }
  try {
    current = (await (loader ?? packLoaders[lang])()).default;
  } catch {
    current = enPack;
  }
  return current;
}

/** The most recently loaded pack (English until loadLocale resolves). */
export function getPack(): LocalePack {
  return current;
}
